import type { ReactNode } from "react";
import { cn } from "@/ui/kit/cn";
import { v } from "./vars";

/** A Ghostty-like window: traffic lights, title, terminal background. */
export function TermWindow({
  title,
  children,
  className,
  bodyClassName,
}: {
  title: string;
  children: ReactNode;
  className?: string;
  bodyClassName?: string;
}) {
  return (
    <div
      className={cn(
        "flex flex-col overflow-hidden rounded-xl shadow-2xl ring-1 ring-black/40",
        className,
      )}
      style={{ background: v("terminal.background") }}
      data-token="terminal.background"
    >
      <div
        className="relative flex h-8 shrink-0 items-center gap-2 px-3"
        style={{
          background: `color-mix(in oklab, ${v("terminal.background")} 82%, ${v("terminal.foreground")})`,
        }}
      >
        <span className="size-3 rounded-full bg-[#ff5f57]" />
        <span className="size-3 rounded-full bg-[#febc2e]" />
        <span className="size-3 rounded-full bg-[#28c840]" />
        <span
          className="absolute inset-x-0 text-center font-sans text-xs"
          style={{ color: v("terminal.foreground"), opacity: 0.75 }}
        >
          {title}
        </span>
      </div>
      <div
        className={cn("preview-mono min-h-0 flex-1 overflow-hidden", bodyClassName)}
        style={{ color: v("terminal.foreground") }}
      >
        {children}
      </div>
    </div>
  );
}
